import { Container, Tabs, Tab } from "react-bootstrap";
import Layout from "wrappers/layout";
import SipCalculator from "./components/SipCalculator";
import CreateSip from "./components/CreateSip";
import SipPassbook from "./components/SipPassbook";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./styles/Style.css";


const SipPage = () => {

  const location = useLocation();
  const history = useHistory();

  const hasSipData = !!(location.state as any)?.sipdata;
  
  const [activeTab, setActiveTab] = useState("create");


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    const toastMessage = params.get("toastMessage");

    // Fix 2: Don't override tab to "create" if sipdata already handled it
    if (tab && !hasSipData) {
      setActiveTab(tab);
    }

    if (toastMessage) {
      toast.success(decodeURIComponent(toastMessage));

      // Fix 3: Preserve location.state when replacing URL
      history.replace(
        { pathname: "/sip", search: "?tab=" + (tab || "create") },
        location.state  // pass state through so CreateSip doesn't lose sipdata
      );
    }
  }, [location.search]);



  const handleInvestmentData = (data: {
    investment: number;
    years: number;
    sipType: string;
  }) => {
    const params = new URLSearchParams({
      tab: "create",
      investment: String(data.investment),
      duration: String(data.years * 12),
      type: data.sipType
    });

    // Switch tab immediately without waiting for useEffect
    setActiveTab("create");
    history.push(`/sip?${params.toString()}`);
  };


  return (
    <Layout>
      <Container fluid className="py-2">
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => {
            const selectedTab = k || "create";
            setActiveTab(selectedTab);
            history.push(`/sip?tab=${selectedTab}`);
          }}
          id="sip-tabs"
          className="sip-tabs mb-4"
          mountOnEnter
          unmountOnExit
        >
          <Tab eventKey="create" title="Create SIP">
            <CreateSip />
          </Tab>

          <Tab eventKey="calculator" title="SIP Calculator">
            <SipCalculator onInvest={handleInvestmentData} />
          </Tab>

          <Tab eventKey="passbook" title="SIP Passbook">
            <SipPassbook />
          </Tab>
        </Tabs>
      </Container>
    </Layout>
  );
};

export default SipPage;
